import { SiteFrame } from '../components/Shell';
import { Hero } from '../sections/Hero';
import { System } from '../sections/System';
import { Journey } from '../sections/Journey';
import { Features } from '../sections/Features';
import { Lifecycle } from '../sections/Lifecycle';
import { QrRedeem } from '../sections/QrRedeem';
import { Team } from '../sections/Team';
import { Reports } from '../sections/Reports';
import { Experience, Faq, FinalCta, Pricing, Security } from '../sections/Closing';

export function HomePage() {
  return <SiteFrame page="home">
    <Hero />
    <System />
    <Journey />
    <Features />
    <Lifecycle />
    <QrRedeem />
    <Team />
    <Reports />
    <Experience />
    <Security />
    <Pricing />
    <Faq />
    <FinalCta />
  </SiteFrame>;
}
